import { ComponentPropsWithoutRef } from "react";

import { IIconProps } from "@/components/icons/IconInterface";

export const FolderIcon = ({ size, color, isFilled, ...props }: ComponentPropsWithoutRef<"svg"> & IIconProps) => {
    if (isFilled) {
        return (
            <svg
                width={ size || 24 }
                height={ size || 24 }
                viewBox="0 0 32 32"
                version="1.1"
                preserveAspectRatio="xMidYMid"
                xmlSpace="preserve"
                { ...props }
            >
                <g>
                    <path
                        d="M32 10.784v14.557c0 1.645-1.354 3-3 3H3c-1.646 0-3-1.355-3-3V6.659c0-1.646 1.354-3 3-3h9.125c.323 0 .627.156.814.42l2.639 3.705H29c1.646 0 3 1.355 3 3z"
                        fill={ color || "currentColor" }
                        opacity="1"
                    ></path>
                </g>
            </svg>
        );
    }

    return (
        <svg width={ size || 24 } height={ size || 24 } viewBox="0 0 32 32" version="1.1" preserveAspectRatio="xMidYMid" xmlSpace="preserve" { ...props }>
            <g>
                <path
                    d="M29 7.783H15.578l-2.639-3.704a.999.999 0 0 0-.814-.42H3c-1.654 0-3 1.346-3 3v18.682c0 1.654 1.346 3 3 3h26c1.654 0 3-1.346 3-3V10.783c0-1.654-1.346-3-3-3zm1 17.558c0 .551-.449 1-1 1H3c-.551 0-1-.449-1-1V6.659c0-.551.449-1 1-1h8.609l2.639 3.704c.188.264.491.42.814.42H29c.551 0 1 .449 1 1z"
                    fill={ color || "currentColor" }
                    opacity="1"
                ></path>
            </g>
        </svg>
    );
};
